import { z } from 'zod';

export const teamSchema = z.object({
  eyebrow: z.string().min(1),
  title: z.string().min(1),
  members: z
    .array(
      z.object({
        name: z.string().min(1),
        role: z.string().min(1),
      }),
    )
    .min(1),
});

export type Team = z.infer<typeof teamSchema>;
